import React from 'react';

export default function InterviewIntro({ session, onBegin }) {
  const questionCount = session?.questions?.length || 0;
  return (
    <div className="max-w-2xl mx-auto p-8 bg-[#fdfaf0] rounded-xl border border-[#1b5e20]/20 shadow-sm">
      <h1 className="text-3xl font-bold text-[#1b5e20] mb-4">Your AI Interview</h1>
      <p className="text-gray-700 mb-6">
        This interview has <span className="font-semibold">{questionCount} personalized questions</span>{' '}
        based on the job description and your profile. Take your time. Aim for specific, concrete
        answers with examples.
      </p>

      <div className="bg-white p-4 rounded-lg mb-6 border border-gray-200">
        <h3 className="font-semibold text-[#b8860b] mb-2">How it works</h3>
        <ul className="text-sm text-gray-600 space-y-1">
          <li>• Read each question carefully</li>
          <li>• Type your answer in the text area</li>
          <li>• Click Next to submit and see the next question</li>
          <li>• After the last question, your results will be generated</li>
        </ul>
      </div>

      <button
        onClick={onBegin}
        className="w-full py-3 bg-[#1b5e20] text-white font-semibold rounded-lg hover:bg-[#2e7d32] transition"
      >
        Begin Interview
      </button>
    </div>
  );
}
